import { proxy, ref } from 'valtio';

import { CompanyProfile, QrScanPayload } from 'models';

export type OpenScan = {
    company: CompanyProfile;
    itemId: string;
    // Still a promise while the scan saves, so visitors can start their note straight away
    scan: QrScanPayload | Promise<QrScanPayload | undefined>;
    retry?: () => void;
    test?: boolean;
    // Opens as the pill, e.g. when a visitor comes back to something they saved
    startCollapsed?: boolean;
    closeWhenDone?: boolean;
};

// The one scan notes sheet the app shows. A QR scan and every "Save to RE+ Showtime" button open it, and
// ScanNotesSheetHost renders it, so a page never shows two sheets and buttons in lists can open it too.
const scanSheetState = proxy({
    open: null as OpenScan | null,
    // Keys the rendered sheet, so opening it again expands a sheet the visitor had minimized
    openCount: 0,
});

const openScanSheet = (open: OpenScan) => {
    scanSheetState.open = ref(open);
    scanSheetState.openCount += 1;
};

export { openScanSheet, scanSheetState };
